/*
 * pg-reviews-merge.js — נוסף 11.8.2026 (קוד מותאם אישית)
 * מחליף את pg-about-reviews.js ומאחד את שני התפקידים.
 *
 * 1. העברת כרטיסי הביקורות מהמטאאובייקטים (#pg-google-reviews)
 *    אל מסילת הקרוסלה של סקשן pg-reviews.
 * 2. בעמוד "הסיפור שלנו" בלבד — שתילת הסקשן כולו לתוך
 *    <div id="pg-reviews-slot"> שבגוף הכתבה. בעמוד המוצר אין slot,
 *    והפונקציה פשוט לא עושה כלום.
 *
 * למה ב-JS ולא ב-Liquid
 * -------------------
 * תגית {% section %} חוקית רק ב-layout וב-template, וסקשן הביקורות
 * הוא קובץ של 20KB שמשרת שני עמודים — ה-API מחייב דחיפת קובץ
 * שלם בכל עדכון, ושגיאה היתה שוברת את שניהם. לכן הכרטיסים
 * מרונדרים בתבניות (צד שרת — קיימים בקוד המקור, חשוב ל-SEO)
 * ומועברים למסילה כאן.
 */
(function () {
  'use strict';

  var SLOT_ID = 'pg-reviews-slot';
  var SECTION_ID = 'shopify-section-pg-reviews';
  var BAG_ID = 'pg-google-reviews';

  function placeSection() {
    var slot = document.getElementById(SLOT_ID);
    var section = document.getElementById(SECTION_ID);
    if (!slot || !section) return;
    if (section.parentNode === slot) return;
    slot.appendChild(section);
  }

  function mergeCards() {
    var bag = document.getElementById(BAG_ID);
    if (!bag) return;
    var track = document.querySelector('#' + SECTION_ID + ' [data-pg-rv-track]');
    if (!track) return; /* אין קרוסלה — משאירים את הכרטיסים במקום */
    var cards = bag.querySelectorAll('.pg-rv__card');
    for (var i = 0; i < cards.length; i++) track.appendChild(cards[i]);
    if (!bag.querySelector('.pg-rv__card') && bag.parentNode) bag.parentNode.removeChild(bag);
  }

  function run() {
    placeSection();
    mergeCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* בעורך הנושאים Shopify מרנדר מחדש את הסקשן אל מקומו המקורי. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail && e.detail.sectionId === 'pg-reviews') run();
  });
})();
